import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

const dashboardApi = {
  getOverviewStats: async (kitchenId?: string) => {
    let url = `${API_URL}/api/admin/dashboard/overview`;
    if (kitchenId) {
      url += `?kitchenId=${encodeURIComponent(kitchenId)}`;
    }
    const response = await axios.get(
      url,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      }
    );

    return response.data;
  },

  getOrderStats: async () => {
    const response = await axios.get(`${API_URL}/api/admin/dashboard/orders`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
      },
    });

    return response.data;
  },

  getSubscriptionStats: async () => {
    const response = await axios.get(
      `${API_URL}/api/admin/dashboard/subscriptions`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      }
    );

    return response.data;
  },

  getUserStats: async () => {
    const response = await axios.get(`${API_URL}/api/admin/dashboard/users`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
      },
    });

    return response.data;
  },
};

export default dashboardApi;
